import React, { useEffect, useState } from 'react';
import { BellRing, X } from 'lucide-react';
import { toast } from 'sonner';
import { pushSupported, currentSubscription, turnOn } from '../lib/pushClient';

const KEY = 'fv-push-prompt-dismissed';

// Shown at the top of the CRM until this device has notifications on.
export const PushPrompt = () => {
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (!pushSupported()) return;
      try {
        const until = Number(localStorage.getItem(KEY) || 0);
        if (until > Date.now()) return;
      } catch (e) { /* storage blocked: still offer */ }
      try {
        const sub = await currentSubscription();
        if (alive && !sub) setShow(true);
      } catch (e) { if (alive) setShow(true); }
    })();
    return () => { alive = false; };
  }, []);

  const enable = async () => {
    setBusy(true);
    try {
      await turnOn({ complaint: true, website_claims: true, new_order: true, whatsapp: true, courier: true, stock: true });
      toast.success('Notifications are on. Change what you get under the bell → Phone notifications.');
      setShow(false);
    } catch (e) {
      toast.error(e.message, { duration: 12000 });
    } finally { setBusy(false); }
  };

  const later = () => {
    try { localStorage.setItem(KEY, String(Date.now() + 3 * 86400000)); } catch (e) { /* ignore */ }
    setShow(false);
  };

  if (!show) return null;
  return (
    <div className="mb-4 flex items-center gap-3 rounded-xl border border-primary/30 bg-primary/5 px-4 py-3">
      <BellRing className="h-5 w-5 shrink-0 text-primary" />
      <p className="flex-1 text-sm">
        <span className="font-semibold">Get notified</span>
        <span className="text-muted-foreground"> about new orders, WhatsApp messages, complaints and stock.</span>
      </p>
      <button type="button" onClick={enable} disabled={busy}
        className="shrink-0 rounded-lg bg-primary px-3 py-1.5 text-sm font-medium text-primary-foreground disabled:opacity-60">
        {busy ? 'Turning on…' : 'Turn on'}
      </button>
      <button type="button" onClick={later} aria-label="Not now" className="shrink-0 p-1 text-muted-foreground hover:text-foreground">
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};

export default PushPrompt;
